import React from "react";
import { useSelector } from "react-redux";
import QuestionContainer from "./QuestionContainer";
import { makeSelectQuestionsBySectionId } from "reducers";

const QuestionList = ({ sectionId, row, col }) => {
	const selectQuestionsBySectionId =
		makeSelectQuestionsBySectionId(sectionId);
	const questions = useSelector((state) =>
		selectQuestionsBySectionId(state, sectionId)
	);
	return (
		questions.length > 0 &&
		questions
			/* filter for questions in the correct section coordinate*/
			.filter(
				(qf) =>
					!qf.coord ||
					(qf.coord && qf.coord.row === row && qf.coord.col === col)
			)
			/* filter excluding any child questions */
			.filter((cq) => !cq.parentQuestionId)
			.map((q) => {
				return (
					<QuestionContainer
						key={q.id}
						question={q}
					></QuestionContainer> //todo:checkerror fix
				);
			})
	);
};

export default QuestionList;
